module.exports = __webpack_public_path__ + "img/Blog_cleaning_1.80d7ceb0.jpg";